module.exports = __webpack_public_path__ + "static/media/etherparty.408a74ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/etherparty.png
// module id = 3278
// module chunks = 0